import styled from 'styled-components';
import { NavTabTrigger, NavTabsList, TabsContent, TabsGroup } from 'ui/tabsGroup';
import { borderRadius, caption, colors, heading4, spacing } from 'ui/theme';
import { TakeOverPanel } from 'ui/takeOver';
import { REVIEW_PANEL_WIDTH } from 'ui/workflows/nodeTilePanel/NodeTilePanel.styled';
import { pxToRem } from 'utils/convert';

export const StyledReview = styled(TakeOverPanel)`
  height: 100%;
  max-width: ${pxToRem(REVIEW_PANEL_WIDTH)};
  max-height: 100%;
  z-index: 2;
  background: ${colors.backgroundSecondary};
`;

export const StyledNav = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${spacing.threeQuarter} ${spacing.base} 0px ${spacing.plusHalf};

  align-items: center;
  gap: ${spacing.half};
  align-self: stretch;
  background: ${colors.backgroundPrimary};
`;

export const StyledNavText = styled.div`
  color: ${colors.textPrimary};
  ${heading4};
`;

export const StyledNavTabGroup = styled(NavTabsList)`
  padding-left: ${spacing.base};
  padding-right: ${spacing.base};
  width: 100%;
  background: ${colors.backgroundPrimary};
`;

export const StyledBody = styled.div`
  display: flex;
  padding: ${spacing.plusHalf};

  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing.base};
  flex: 1 0 0;
  align-self: stretch;
`;

export const StyledBodyHeader = styled.div`
  align-self: stretch;
  ${caption};
  color: ${colors.textSecondary};
`;

export const StyledNavTabTrigger = styled(NavTabTrigger)`
  display: flex;
  padding: ${spacing.fiveEights} ${spacing.threeQuarter};
  justify-content: center;
  align-items: center;
  gap: ${spacing.half};
  border-radius: ${borderRadius.full};
`;

export const StyledTabsGroup = styled(TabsGroup)`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const StyledTabsContent = styled(TabsContent)`
  overflow-y: auto;
`;
